export default __webpack_public_path__ + "static/media/CandidatesIcon.c70ccfdd.svg";